import type { Theme } from '../types';
import { Clouds } from './Clouds';

// Sky — the v1 default. Brand colour #52C5F0 from the prototype.
// Decoration: drifting white clouds, fixed-position behind content.
export const skyTheme: Theme = {
  key: 'sky',
  name: 'Taivas',
  tokens: {
    bodyBackground: 'linear-gradient(180deg, #52c5f0 0%, #a8dff5 55%, #e3f5fd 100%)',
    pageHeadingColor: '#ffffff',
    pageHeadingShadow: '0 4px 0 rgba(0, 90, 160, 0.18)',
    routineCardSurface: 'rgba(255, 255, 255, 0.55)',
    cardSurface: 'rgba(255, 255, 255, 0.7)',
    accent: '#52C5F0',
  },
  decoration: { kind: 'component', component: Clouds },
  routineCardPalette: ['#fcd34d', '#93c5fd', '#86efac', '#fb7185', '#c4b5fd', '#fdba74'],
};
